import { render, staticRenderFns } from "./housingCunAdd.vue?vue&type=template&id=0c909139"
import script from "./housingCunAdd.vue?vue&type=script&lang=js"
export * from "./housingCunAdd.vue?vue&type=script&lang=js"
import style0 from "./housingCunAdd.vue?vue&type=style&index=0&id=0c909139&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports